import React from 'react';
import PropTypes from 'prop-types';
import { Card, Col, Row } from 'react-bootstrap';
import BasicECharts from 'components/common/BasicEChart';
import { PieChart } from 'echarts/charts';
import * as echarts from 'echarts/core';
import { getColor } from 'helpers/utils';

import {
  GridComponent,
  TitleComponent,
  TooltipComponent
} from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  PieChart,
  CanvasRenderer
]);

const ForestCover = ({ data, areaName, radius, series }) => {
  const colors = [
    'primary', // You can replace these with regular color names or hex values
    'secondary' // You can replace these with regular color names or hex values
  ];
  const getOptions = (data, areaName, radius, series) => {
    const firstData = data.find(item => item.name === series[0]) || {
      value: 0
    };
    const secondData = data.find(item => item.name === series[1]) || {
      value: 0
    };

    return {
      color: colors.map(color => getColor(color)),
      tooltip: {
        padding: [7, 10],
        transitionDuration: 0,
        backgroundColor: getColor('gray-100'),
        borderColor: getColor('gray-300'),
        textStyle: { color: getColor('dark') },
        borderWidth: 1,
        formatter: params =>
          `<strong>${params.data.name}:</strong> ${params.percent.toFixed(2)}%`
      },
      series: [
        {
          name: areaName,
          type: 'pie',
          radius,
          avoidLabelOverlap: false,
          emphasis: {
            scale: false
          },
          itemStyle: {
            borderWidth: 2,
            borderColor: getColor('gray-100')
          },
          label: {
            show: true,
            position: 'center',
            formatter: '{a}',
            fontSize: 16,
            color: getColor('dark')
          },
          data: [
            { name: series[0], value: firstData.value },
            { name: series[1], value: secondData.value }
          ]
        }
      ]
    };
  };

  return (
    <Card className="h-md-100">
      <Card.Body className="z-index-1 d-flex flex-column justify-content-start">
        <Row className="flex-column align-items-center justify-content-between">
          <Col className="pe-2 flex-column align-items-center justify-content-center">
            {data.map((item, index) => (
              <div key={index} className="fw-semi-bold fs--2">
                <FontAwesomeIcon
                  icon="circle"
                  className={`me-2 text-${colors[index] || 'info'}`} // Adjust the class here
                />
                {item.name}: {item.value}%
              </div>
            ))}
          </Col>
          <Col xs={12} className="mt-6">
            <div className="d-flex justify-content-center align-items-center">
              <BasicECharts
                echarts={echarts}
                options={getOptions(data, areaName, radius, series)}
                style={{ width: '15.625rem', height: '15.625rem' }}
              />
            </div>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

ForestCover.propTypes = {
  data: PropTypes.array.isRequired,
  areaName: PropTypes.string.isRequired,
  radius: PropTypes.array.isRequired,
  series: PropTypes.array.isRequired
};

export default ForestCover;
